import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FilterSelect from '../components/common/FilterSelect';

const docs = [
  { title: 'Documento politico "L\'Italia che vogliamo"', date: '15 Mar 2026', type: 'Documento', badge: 'PDF' },
  { title: 'Statuto dei Giovani Democratici — Edizione 2024', date: '10 Gen 2024', type: 'Statuto', badge: 'PDF' },
  { title: 'Regolamento Congressi e Assemblee', date: '5 Dic 2023', type: 'Regolamento', badge: 'PDF' },
  { title: 'Mozione sul trasporto pubblico giovanile', date: '5 Mar 2026', type: 'Mozione', badge: 'PDF' },
  { title: 'Rapporto annuale attività 2025', date: '15 Gen 2026', type: 'Report', badge: 'PDF' },
  { title: 'Proposta di legge "Abitare Giovane"', date: '20 Feb 2026', type: 'Proposta', badge: 'PDF' },
  { title: 'Bilancio consuntivo 2025', date: '28 Feb 2026', type: 'Bilancio', badge: 'PDF' },
];

const DocumentiPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Documenti' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Trasparenza" title="Documenti" subtitle="Statuti, regolamenti, documenti politici, mozioni e bilanci dei Giovani Democratici." />
      <section className="section section--sm"><div className="container">
        <Toolbar className="mb-6"
          left={<SearchBar placeholder="Cerca documento..." ariaLabel="Cerca" />}
          right={
            <>
              <FilterSelect label="Tipo Documento" options={['Tutti', 'Documenti Politici', 'Statuti', 'Mozioni', 'Report', 'Proposte', 'Bilanci']} />
              <FilterSelect label="Anno" options={['Tutti', '2026', '2025', '2024', '2023']} />
            </>
          }
        />
        <div className="flex flex-col gap-3">
          {docs.map((d) => (
            <a href="#" className="card flex justify-between items-center" style={{ padding: 'var(--space-5)' }} key={d.title}>
              <div style={{ flex: 1 }}>
                <span className="badge badge--subtle mb-2">{d.type}</span>
                <h4 className="mb-1">{d.title}</h4>
                <span className="text-meta">{d.date}</span>
              </div>
              <span className="badge badge--primary">{d.badge}</span>
            </a>
          ))}
        </div>
      </div></section>
    </Layout>
  );
};

export default DocumentiPage;
